// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"20efb2fb","787":"4f57ac2b"}[chunkId] + ".chunk.js";
};